import { mapState, mapActions } from 'vuex'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import AdjustmentModal from '@/components/modals/adjustment-modal/adjustment-modal.vue'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'Adjustments',
  components: {
    IcEdit,
    Scrollbar,
    AdjustmentModal
  },
  props: {
    adminShiftId: {
      type: Number | String
    },
    adjustments: {
      /**
       * {
       *   adjustments_list: Array<{ description, payment_type, amount, adjustment_id }>,
       *   adjustments_sum: number
       * }
       */
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editedAdjustment: null
    }
  },
  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    })
  },
  methods: {
    ...mapActions({
      editAdjustment: 'shiftReport/editAdjustment'
    }),
    getAmountStr(amount) {
      let result = ''
      if (amount > 0) {
        result += '+'
      }
      result += `${numberWithSeparator(amount)} ₽`
      return result
    },
    openEditAdjustmentModal(adjustment) {
      this.editedAdjustment = adjustment
      this.$nextTick(() => {
        this.$refs['adjustment-modal'].show()
      })
    },
    async onEditAdjustment(event) {
      await this.editAdjustment({
        admin_shift_id: this.adminShiftId,
        data: event
      })
      this.$refs['adjustment-modal'].hide()
      this.$emit('adjustment-changed')
    },
    onAdjustmentHide() {
      this.editedAdjustment = null
    }
  }
}